<template>
  <div class="notice-container">
    <div class="notice-content">
      <h1 class="title">纪检举报信箱</h1>
      <div class="notice-box">
        <h2>写信须知</h2>
        <div class="notice-text">
          <p>欢迎使用纪检举报信箱系统。在提交信件前，请仔细阅读以下须知：</p>
          <ol>
            <li>本系统用于接收申诉、举报和建议，请如实填写相关信息。</li>
            <li>您可以选择匿名或实名方式提交信件。</li>
            <li>提交的信件将严格保密，仅授权管理人员可查看。</li>
            <li>请确保所提供的信息真实有效，不得恶意举报或虚假申诉。</li>
            <li>上传的附件请确保格式正确，支持PDF、Word、图片、视频等格式。</li>
            <li>系统将及时处理您的信件，请耐心等待处理结果。</li>
          </ol>
          <p class="warning">
            请认真阅读以上内容，确保了解相关要求后再进行下一步操作。
          </p>
        </div>
        <div class="timer-box">
          <p>请阅读 {{ remainingTime }} 秒后继续</p>
          <el-progress
            :percentage="progress"
            :status="canProceed ? 'success' : ''"
            :show-text="false"
          ></el-progress>
        </div>
        <el-button
          type="primary"
          size="large"
          :disabled="!canProceed"
          @click="goToForm"
          class="next-btn"
        >
          下一步
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notice",
  data() {
    return {
      remainingTime: 3,
      canProceed: false,
      timer: null,
    };
  },
  computed: {
    progress() {
      return ((3 - this.remainingTime) / 3) * 100;
    },
  },
  mounted() {
    this.startTimer();
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.remainingTime--;
        if (this.remainingTime <= 0) {
          this.canProceed = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    goToForm() {
      if (this.canProceed) {
        this.$router.push("/form");
      }
    },
  },
};
</script>

<style scoped>
.notice-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.notice-content {
  width: 100%;
  max-width: 800px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
  padding: 30px 20px;
  font-size: 32px;
  font-weight: bold;
  margin: 0;
}

.notice-box {
  padding: 40px;
}

.notice-box h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
  border-bottom: 2px solid #667eea;
  padding-bottom: 10px;
}

.notice-text {
  line-height: 1.8;
  color: #666;
  margin-bottom: 30px;
}

.notice-text ol {
  margin: 20px 0;
  padding-left: 30px;
}

.notice-text li {
  margin: 10px 0;
}

.warning {
  color: #e74c3c;
  font-weight: bold;
  margin-top: 20px;
}

.timer-box {
  background: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
  text-align: center;
}

.timer-box p {
  margin-bottom: 15px;
  font-size: 16px;
  color: #333;
}

.next-btn {
  width: 100%;
  height: 50px;
  font-size: 18px;
}

@media (max-width: 768px) {
  .notice-box {
    padding: 20px;
  }

  .title {
    font-size: 24px;
    padding: 20px;
  }

  .notice-box h2 {
    font-size: 20px;
  }
}
</style>

